const C = { bg: "#111", border: "#1e1e1e", accent: "#e8700a", text: "#f5f5f5", dim: "#666" };

export function HorizontalBar({ items, unit = "", showPct = true, color }) {
  if (!items || items.length === 0) return <div style={{ color: C.dim, fontSize: 12, padding: "8px 0" }}>Sin datos</div>;
  const max = Math.max(...items.map(i => i.value), 1);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {items.map((item, idx) => (
        <div key={idx}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span style={{ fontSize: 12, color: C.text, maxWidth: "60%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.label}</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: color || C.accent }}>
              {unit}{typeof item.value === "number" ? item.value.toLocaleString("es-AR") : item.value}
              {showPct && item.pct != null && <span style={{ color: C.dim, fontWeight: 400, marginLeft: 4 }}>({item.pct}%)</span>}
            </span>
          </div>
          <div style={{ height: 4, background: "#1e1e1e", borderRadius: 2, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${(item.value / max) * 100}%`, background: item.color || color || C.accent, borderRadius: 2, transition: "width .4s ease" }} />
          </div>
        </div>
      ))}
    </div>
  );
}
